/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MessageGroupRequest = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        companyId: {
    type: 'number',
    isRequired: true,
},
        employees: {
    type: 'array',
    contains: {
    type: 'number',
},
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
        createdAt: {
    type: 'string',
    isRequired: true,
},
    },
};